<template>
  <tile class="opc-zsched">
    <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h1 class="opc-zm-base-card__name text-capitalize">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h1>
          <div class="opc-zm-base-card__view-detail-button">
            <zm-button
              class="opc-zm-base-card__link"
              type="link"
              @click="handlePlanDetailsClick"
              v-if="isExpanded && showPlanDetail"
            >
              {{ $t('billing.plan_details') }}
            </zm-button>
          </div>
          <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            {{
              $t('billing.zone.desc1', [
                form.selectedNumber,
                $money(formPlan ? formPlan.amount : 0),
                $t('billing.trial.unit_suffix', [$t(`billing.common.per_billing_cycle_user.${form.billingCycle}`)]),
              ])
            }}
          </div>
        </div>
      </div>
      <div class="opc-zsched__trial-desc">
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
          {{ $t('billing.scheduler.free_trial_descriptions.duration', [trialDays]) }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.sharelink') }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.customizable') }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.cancel') }}
        </p>
      </div>
      <div class="opc-zsched__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item :label="$t('billing.select_billing_cycle')" id="opc-zsched__billing-cycle">
            <zm-radio-group
              v-model="form.billingCycle"
              @change="submitForm"
              aria-labelledby="opc-zsched__billing-cycle"
              role="radiogroup"
              class="opc-card-radio"
              tabindex="-1"
            >
              <zm-tooltip
                v-for="plan in currentPlans"
                :key="plan.billing_cycle"
                :disabled="!billingCycleDisabled(plan.billing_cycle)"
                tabindex="-1"
              >
                <div slot="content" v-html="billingCycleDisabled(plan.billing_cycle) || ''" />
                <zm-radio
                  tabindex="0"
                  :key="plan.billing_cycle"
                  :label="plan.billing_cycle"
                  :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                  class="opc-zsched__radio"
                >
                  <p class="opc-zsched__radio-title first-capitalize">
                    {{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}
                    <save-count
                      v-if="plan.cycleValue >= BillingCycleEnum()[BILLING_CYCLE.QUARTERLY]"
                      :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                      :annual-price="(plan.amount / plan.cycleValue) * 12"
                      :monthly-price="cyclePrice.shortestCycleMonthlyPrice"
                    />
                  </p>
                  <p class="opc-zsched__radio-price" tabindex="-1">
                    <span>
                      {{ $money(plan.amount, { forceDiff: true }) }}
                    </span>
                    <span class="opc-zsched__radio-price-unit">{{ $t('billing.trial.unit_suffix', [getPlanUnitWithCycle(plan.billing_cycle)]) }}</span>
                  </p>
                </zm-radio>
              </zm-tooltip>
            </zm-radio-group>
          </zm-form-item>
        </zm-form>
      </div>
      <div class="opc-zsched__free-trial-footer" v-html="$t('billing.scheduler.free_trial_footer', [paidPurchaseLink])" @click="clickBuyNow"/>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import baseFormMixin from '@/plans/ZOOM_SCHEDULER/mx/base';
import formMixin from '@/plans/ZOOM_SCHEDULER/mx/index';
import saveMixins from '../../ZOOM_MEETING/save-mixins';
import { BillingCycleEnum } from '@/common/constants';
export default {
  methods: {
    BillingCycleEnum() {
      return BillingCycleEnum;
    },
  },
  mixins: [baseFormMixin, formMixin, saveMixins],
  components: {
    Foldable,
    Tile,
  },
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@/styles/responsive.scss';

.opc-zsched {
  .main-icon {
    color: $theme-color;
  }

  &__trial-desc {
    margin: 14px 0 0 60px;
    @include media(mobile, tablet){
      margin: 14px 30px;
    }
  }
  &__desc-text {
    display: flex;
    align-items: center;
    color: #00053d;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 4px 0;
    img {
      display: inline-block;
      margin-right: 4px;
    }
  }
  &__free-trial-footer {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #666487;
    a {
      color: #0B5CFF;
    }
  }
  .opc-card-radio {
    margin-top: 8px;

    .opc-zsched__radio {
      width: 100%;
      .zm-radio__wrap {
        width: 100%;
      }
    }
  }
  .opc-card-radio &__radio {
    .zm-radio__label--inner {
      width: 100%;
      min-height: 90px;
      padding: 16px;
    }
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: #00053d;
      margin: 0;
    }
    &-price {
      font-style: normal;
      font-weight: 700;
      font-size: 22px;
      line-height: 33px;
      color: #00053d;
      &-unit {
        font-weight: 450;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>
